/* eslint-disable react/prop-types */
import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setEventMeta, setEventInfo } from '../redux/actions/pricing';
import { validateAbTest } from '../helpers/ab-test';
import { fetchEventMeta, setEventLinks, tmMatching, fetchSBEventMeta } from '../services/killshot';

const MetaContext = React.createContext();

export function MetaProvider(props) {
  const { match } = props;
  const eventId = match?.params?.event_id;
  const [eventMeta, setEventMeta2] = useState({});
  const [loadingEventMeta, setLoadingEventMeta] = useState(true);
  const [skyboxId, setSkyboxId] = useState('');
  const history = useHistory();
  const dispatch = useDispatch();

  const eventMetaSelector = eventMetas => ({
    ...eventMetas,
    is_ab_test: eventMetas.is_ab_test && validateAbTest(),
  });

  const fetchData = async () => {
    try {
      const metaResponse = await fetchEventMeta(eventId);
      const tmUrl = metaResponse.response.links.find(item => item.name === 'TicketMaster' || item.name === 'LiveNation')
        ?.url;
      tmMatching(metaResponse.response.skybox_id, metaResponse.response.event_id, tmUrl);
      setEventMeta2(metaResponse.response);
      dispatch(setEventMeta(eventMetaSelector(metaResponse.response)));
      setLoadingEventMeta(false);

      if (metaResponse) {
        const sbId = metaResponse.response.skybox_id;
        const eventInfo = await fetchSBEventMeta(sbId);
        dispatch(setEventInfo(eventInfo?.response));
        setSkyboxId(sbId);
      }
    } catch (e) {
      setLoadingEventMeta(false);
    }
  };

  const handleEventLinks = async (eventURL = '', type) => {
    let baseUrl = '';
    if (type === 'axs') {
      baseUrl = `v1/event/map/axs/${eventId}`;
    } else if (type === 'stubhub') {
      baseUrl = `v1/event/request_stubhub_link_change/${skyboxId}`;
    }
    const data = await setEventLinks(baseUrl, eventURL);

    setLoadingEventMeta(true);
    return data;
  };

  useEffect(() => {
    fetchData();
  }, [history.location.pathname]);

  const value = useMemo(
    () => ({
      eventMeta,
      loadingEventMeta,
      fetchData,
      handleEventLinks,
    }),
    [eventMeta, loadingEventMeta]
  );

  return <MetaContext.Provider value={value} {...props} />;
}

export function useMetaContext() {
  const context = React.useContext(MetaContext);

  if (!context) {
    throw new Error('useMetaContext must belong to MetaContext');
  }

  return context;
}
